function CustomReport() {
  return <div>Banners</div>;
}

export default CustomReport;
